/*
 * File: 基础设置-组织架构-同步日志管理-变更处理
 */
<template>
    <el-dialog
        :visible="visible"
        width="60vw"
        title="用户信息变更详情"
        custom-class="organization-log-process-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <div class="organization-log-process-title">
            <el-col :span="6" style="padding-left: 8px;">字段</el-col>
            <el-col :span="6">原值</el-col>
            <el-col :span="6">新值（UAP）</el-col>
            <el-col :span="6">编辑新值</el-col>
        </div>
        <el-form
            :model="formData"
            label-position="left"
            label-width="25%"
            :disabled="+formData.processStatus === 1"
            v-loading="formLoading"
        >
            <el-form-item
                v-show="item.visible"
                v-for="(item, index) in formData.uapUserChangeDetailList"
                :key="index"
                :class="item.required && (!item.editValue || !item.editValue.length) ? 'is-error' : ''"
            >
                <template v-slot:label>
                    <span v-if="item.required" style="color: #f56c6c;margin-right: 4px;">*</span>
                    <span>{{ item.fieldName }}</span>
                </template>
                <el-col :span="8">{{ item.oldValueName || item.oldValue || '-' }}</el-col>
                <el-col :span="8">{{ item.newValueName || item.newValue || '-' }}</el-col>
                <el-col :span="8">
                    <!-- 用户层级、账号状态、在职状态 -->
                    <el-select
                        v-if="['userLevelCode', 'enableFlag', 'employeeStatus', 'marketingSystem'].includes(item.changeField)"
                        v-model="item.editValue"
                        filterable
                        clearable
                        :disabled="!item.canEdit"
                        placeholder="请选择"
                        @change="(val) => handleChange(val, item.changeField)"
                    >
                        <el-option v-for="(val, index) in item.options" :key="index" :label="val.label" :value="val.value" />
                    </el-select>
                    <!-- 上级经理 -->
                    <lots-md-input
                        v-else-if="item.changeField === 'superiorName'"
                        :label="item.editValue"
                        :config="{
                            name: item.fieldName,
                            label: item.fieldName,
                            value: item.changeField,
                            advanceConfig: [
                                { 'prop': 'userName', 'value': '姓名' },
                                { 'prop': 'userCode', 'value': '账号' }
                            ],
                            tableConfig: [
                                { 'prop': 'userName', 'value': '姓名' },
                                { 'prop': 'userCode', 'value': '账号' },
                                { 'prop': 'crmPositionName', 'value': '岗位' },
                                { 'prop': 'userLevelName', 'value': '层级' }
                            ],
                            prefix: '/api-lcrm',
                            method: 'post',
                            advanceUrl: '/lcrm/org/user/selectByCondition',
                            cbParams: ['userName#superiorName', 'userCode#superiorCode'],
                            beforeRequest: (params) => {
                                params.isManage = 1;
                                params.orgCode = formData.orgCode;
                                return params;
                            }
                        }"
                        :cascadeData="item"
                        :disabled="!item.canEdit"
                        @change="(val) => handleChange(val, item.changeField)"
                    />
                    <el-input v-else v-model="item.editValue" :disabled="!item.canEdit" clearable placeholder="请输入" />
                    <div v-if="item.required && (!item.editValue || !item.editValue.length)" class="el-form-item__error">{{ `${item.fieldName}不能为空` }}</div>
                </el-col>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button size="small" @click="handleClose">取消</el-button>
            <el-button
                type="primary"
                size="small"
                @click="handleSave"
                :disabled="+formData.processStatus === 1"
                :loading="isLoading"
            >保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';
import { Message } from 'element-ui';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import lotsMdInput from '@/components/lots/lotsMdInput';
import { getOrganizationLogProcess, saveOrganizationLog } from '@mdm/api/basicSettings/organization.js';
import { config as configStatic } from '../config';

export default {
    components: { lotsMdInput },
    props: {},
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const config = reactive(configStatic);
        const visible = ref(false);
        const formData = ref({});
        const dictData = ref({});
        const formLoading = ref(false);
        const isLoading = ref(false);

        const show = async (id, dict) => {
            visible.value = true;
            formLoading.value = true;
            dictData.value = dict;
            const { data } = await getOrganizationLogProcess({ id });

            // 处理变更详情数据
            if (data?.uapUserChangeDetailList) {
                const userLevelNameData = data.uapUserChangeDetailList.find((v) => v.changeField === 'userLevelName');
                data.uapUserChangeDetailList.forEach((v) => {
                    v.visible = v.display;
                    v.fieldName = v.changeFieldName;
                    v.required = ['positionName', 'enableFlag'].includes(v.changeField);
                    // 用户层级
                    if (v.changeField === 'userLevelCode') {
                        v.visible = userLevelNameData.display;
                        v.fieldName = userLevelNameData.changeFieldName;
                        v.oldValueName = formatDictCodeToName(v.oldValue, dict['LCRM_USER_LEVEL']);
                        v.newValueName = formatDictCodeToName(v.newValue, dict['LCRM_USER_LEVEL']);
                        v.options = formatDict(dict['LCRM_USER_LEVEL']);
                        data.userLevelCode = v?.editValue;
                    }
                    if (v.changeField === 'userLevelName') {
                        data.userLevelName = v?.editValue;
                        v.visible = false;
                    }
                    // 账号状态
                    if (v.changeField === 'enableFlag') {
                        v.oldValueName = formatDictCodeToName(v.oldValue, dict['LCRM_USER_STATUS']);
                        v.newValueName = formatDictCodeToName(v.newValue, dict['LCRM_USER_STATUS']);
                        v.options = formatDict(dict['LCRM_USER_STATUS']);
                    }
                    if (v.changeField === 'superiorCode') {
                        data.superiorCode = v?.editValue;
                    }
                    if (v.changeField === 'superiorName') {
                        data.superiorName = v?.editValue;
                    }
                    // 在职状态
                    if (v.changeField === 'employeeStatus') {
                        v.oldValueName = formatDictCodeToName(v.oldValue, dict['LCRM_USER_EMPLOYEE_STATUS']);
                        v.newValueName = formatDictCodeToName(v.newValue, dict['LCRM_USER_EMPLOYEE_STATUS']);
                        v.options = formatDict(dict['LCRM_USER_EMPLOYEE_STATUS']);
                    }
                    // 营销系统
                    if (v.changeField === 'marketingSystem') {
                        v.oldValueName = formatDictCodeToName(v.oldValue, dict['MARKETING_SYSTEM_TYPE']);
                        v.newValueName = formatDictCodeToName(v.newValue, dict['MARKETING_SYSTEM_TYPE']);
                        v.options = formatDict(dict['MARKETING_SYSTEM_TYPE']);
                        data.marketingSystemCode = v?.editValue;
                    }
                });
            }

            formData.value = { ...data } || {};
            formLoading.value = false;
        };
        const handleClose = () => {
            visible.value = false;
        };
        // 监听下拉选择
        const handleChange = (val, field) => {
            // 用户层级
            if (field === 'userLevelCode') {
                formData.value.userLevelCode = val;
                formData.value.userLevelName = formatDictCodeToName(val, dictData.value['LCRM_USER_LEVEL']);
            }
            // 上级经理
            if (field === 'superiorName') {
                formData.value.superiorCode = val.superiorCode;
                formData.value.superiorName = val.superiorName;
            }
            // 营销系统
            if (field === 'marketingSystem') {
                formData.value.marketingSystemCode = val;
            }
        };
        // 保存
        const handleSave = () => {
            let valid = true;
            formData.value.uapUserChangeDetailList && formData.value.uapUserChangeDetailList.forEach((item) => {
                if (item.required && (!item.editValue || !item.editValue.length)) {
                    valid = false;
                }
            });
            if (!valid) return;
            const uapUserChangeDetailList = formData.value.uapUserChangeDetailList?.map((v) => {
                // 用户层级
                if (v.changeField === 'userLevelCode') {
                    v.editValue = formData.value.userLevelCode;
                }
                if (v.changeField === 'userLevelName') {
                    v.editValue = formData.value.userLevelName;
                }
                // 上级经理
                if (v.changeField === 'superiorCode') {
                    v.editValue = formData.value.superiorCode;
                }
                if (v.changeField === 'superiorName') {
                    v.editValue = formData.value.superiorName;
                }
                // 营销系统
                if (v.changeField === 'marketingSystem') {
                    v.editValue = formData.value.marketingSystemCode;
                }
                return v;
            });
            const params = {
                id: formData.value.id,
                userCode: formData.value.userCode,
                orgCode: formData.value.orgCode,
                changeType: formData.value.changeType,
                handleStatus: '2',
                uapUserChangeDetailList
            };
            // console.log('params', params);
            isLoading.value = true;
            saveOrganizationLog(params).then((res) => {
                isLoading.value = false;
                if (res && +res.code === 0) {
                    Message.success('保存成功');
                    emit('confirm');
                    handleClose();
                }
            });
        };
        // 字典转换
        const formatDict = (dict) => {
            return Object.entries(dict).map((v) => {
                return {
                    value: v[0],
                    label: v[1]
                };
            });
        };

        return {
            config,
            visible,
            formData,
            formLoading,
            isLoading,
            show,
            handleClose,
            handleChange,
            handleSave
        };
    }
};
</script>

<style lang="less">
.organization-log-process-dialog {
    .el-dialog__body {
        padding: 20px 20px 0px 20px;
    }
    .organization-log-process-title {
        height: 32px;
        line-height: 32px;
        background-color: #f5f6f7;
        margin-bottom: 10px;
    }
    .el-select, .el-cascader {
        width: 100%;
    }
    .el-form-item__error {
        left: 66.6%;
    }
}
</style>
